export interface Event {
  title;
  date;
  link;
}

export const events: Event[] = [
  {
    title: 'Seattle Code Camp 2018',
    date: '2018-09-15',
    link:
      'https://www.eventbrite.com/e/seattle-code-camp-2018-tickets-43893723308',
  },
  {
    title: 'AI and Creativity - A Design Discussion Presented by Microsoft',
    date: '2018-09-20',
    link:
      'https://www.eventbrite.com/e/ai-and-creativity-a-design-discussion-presented-by-microsoft-tickets-48609584576',
  },
  {
    title: 'GeekWire Summit 2018',
    date: '2018-10-01',
    link:
      'https://www.eventbrite.com/e/geekwire-summit-2018-tickets-38842671476?aff=es2',
  },
  {
    title: 'Seattle Biz-Tech Summit',
    date: '2018-10-14',
    link:
      'https://www.eventbrite.com/e/seattle-biz-tech-summit-tickets-35059106732',
  },
  {
    title: 'ConveyUX 2019',
    date: '2019-03-11',
    link:
      'https://www.eventbrite.com/e/the-seattle-user-experience-conference-conveyux-2019-tickets-48490792265',
  },
];



// WEBPACK FOOTER //
// ./src/app/_data/events.ts